import { Flex, Text } from "@chakra-ui/react";
import * as React from "react";

import { useChoiceByDate } from "@/hooks/useChoiceByDate";

import { shifts } from "../constants";

type FireDrillShiftProps = {
  auditDate: Date | undefined;
};

export const FireDrillShift = React.memo(
  ({ auditDate }: FireDrillShiftProps) => {
    const shiftChoice = useChoiceByDate(auditDate, shifts.length);

    return (
      <Flex>
        <Text as="b">Required Shift:</Text>
        <Text marginLeft="5px">{shifts[shiftChoice]}</Text>
      </Flex>
    );
  },
);
